import {
    NEW_PRODUTO_AGRICOLA_CADASTRO_SUCCESS,
    CANCEL_PRODUTO_AGRICOLA_CADASTRO_RAPIDO,
    CANCEL_PRODUTO_AGRICOLA_CADASTRO_RAPIDO_SUCCESS,
    TABLE_PRODUTO_AGRICOLA_CADASTRO_PENDING,
    TABLE_PRODUTO_AGRICOLA_CADASTRO_SUCCESS,
    TABLE_PRODUTO_AGRICOLA_CADASTRO_FAILURE,
    LIST_PRODUTO_AGRICOLA_CADASTRO_PENDING,
    LIST_PRODUTO_AGRICOLA_CADASTRO_SUCCESS,
    LIST_PRODUTO_AGRICOLA_CADASTRO_FAILURE,
    FIND_PRODUTO_AGRICOLA_CADASTRO_PENDING,
    FIND_PRODUTO_AGRICOLA_CADASTRO_SUCCESS,
    FIND_PRODUTO_AGRICOLA_CADASTRO_FAILURE,
    DELETE_PRODUTO_AGRICOLA_CADASTRO_PENDING,
    DELETE_PRODUTO_AGRICOLA_CADASTRO_SUCCESS,
    DELETE_PRODUTO_AGRICOLA_CADASTRO_FAILURE,
    CREATE_PRODUTO_AGRICOLA_CADASTRO_PENDING,
    CREATE_PRODUTO_AGRICOLA_CADASTRO_SUCCESS,
    CREATE_PRODUTO_AGRICOLA_CADASTRO_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function produtoAgricolaCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_PRODUTO_AGRICOLA_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case LIST_PRODUTO_AGRICOLA_CADASTRO_PENDING:
        case FIND_PRODUTO_AGRICOLA_CADASTRO_PENDING:
        case DELETE_PRODUTO_AGRICOLA_CADASTRO_PENDING:
        case CREATE_PRODUTO_AGRICOLA_CADASTRO_PENDING:
        case TABLE_PRODUTO_AGRICOLA_CADASTRO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_PRODUTO_AGRICOLA_CADASTRO_RAPIDO:
        case CANCEL_PRODUTO_AGRICOLA_CADASTRO_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_PRODUTO_AGRICOLA_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_PRODUTO_AGRICOLA_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_PRODUTO_AGRICOLA_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_PRODUTO_AGRICOLA_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_PRODUTO_AGRICOLA_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_PRODUTO_AGRICOLA_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_PRODUTO_AGRICOLA_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_PRODUTO_AGRICOLA_CADASTRO_SUCCESS:
        case CREATE_PRODUTO_AGRICOLA_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_PRODUTO_AGRICOLA_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { produtoAgricolaCadastroReducer };